export default __webpack_public_path__ + "static/media/Effortless ScalabilityHeader.5c75f93f.png";